import { APIError } from "./errors";

export function isAPIError(error: unknown): error is APIError {
  return error instanceof APIError;
}

export function errorIsStatus(error: unknown, status: number | number[]) {
  if (!isAPIError(error)) {
    return false;
  }

  const statuses = Array.isArray(status) ? status : [status];

  return statuses.includes(error.status);
}
